import { CLEAR_SESSION, SET_SESSION } from './types';
import { AUTH_LOGIN_SUCCESS } from '../pages/login/types'

const initialState = {
  current: null,
};

export default function sessionReducer(state = initialState, action = {}) {
  switch (action.type) {
    case SET_SESSION:
      return {
        ...state,
        current: action.payload,
      };
    case CLEAR_SESSION:
      return {
        ...state,
        current: null,
      };
    case AUTH_LOGIN_SUCCESS:
      // Spread the existing current (which setSession just populated with
      // `{ token, refreshToken, tenant, user }` from completeLogin) so we
      // keep `user` alongside the fresh tokens. The previous version
      // overwrote current with a token-only object, so any code that read
      // `state.session.current.user` (or that round-tripped via
      // refreshSession's `{ ...current, token, refreshToken }` and stored
      // that user-less shape in localStorage) lost the inflated /me payload.
      return {
        ...state,
        current: {
          ...state.current,
          token: action.payload.token,
          refreshToken: action.payload.refreshToken,
          tenant: action.payload.tenant,
        }
      };
    default:
      break;
  }
  return state;
}
